const GradientButton = ({ children, onClick, className, loading = false, disabled = false }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={`relative rounded-2xl font-semibold transition-all flex items-center justify-center gap-2 ${className}`}
      style={{
        background: 'linear-gradient(45deg, #D0413A, #F4B18B)',
        color: '#F9E4D9',
      }}>
      {loading && (
        <svg className="w-5 h-5 animate-spin"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10"
            stroke="currentColor" strokeWidth="4">
          </circle>
          <path className="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z">
          </path>
        </svg>
      )}
      <div className={`flex items-center gap-2 ${loading ? "opacity-50" : ""}`}>
        {children}
      </div>
    </button>
  );
};

export default GradientButton;